// Hosted payment field tab order (Adyen / Braintree iframes).
//
// Positive tabindex values keep the right-column Continue button (earlier in the
// DOM) last in tab order while still visiting card fields before address fields.

export const CARD_FIELD_TABINDEX_START = 5;

const BRAINTREE_IFRAME_SELECTORS = [
	'#braintree_field_credit_card_v3 iframe',
	'#braintree_field_date_v3 iframe',
	'#braintree_field_cvv_v3 iframe',
	'#braintree_field_postal_code_v3 iframe',
];

/**
 * @param {number} scene Checkout step (1 = payment on left, 2 = review).
 * @param {Document} [doc]
 */
export const syncPaymentFieldTabOrder = (scene = 1, doc = typeof document !== 'undefined' ? document : null) => {
	if (!doc) {
		return;
	}

	let offset = 0;
	const assign = (el) => {
		if (!el) {
			return;
		}
		const visible = el.offsetWidth > 0 || el.offsetHeight > 0;
		if (scene === 1 && visible) {
			el.tabIndex = CARD_FIELD_TABINDEX_START + offset;
			offset += 1;
		} else {
			el.tabIndex = -1;
		}
	};

	doc.querySelectorAll('#adyen-checkout-container iframe').forEach(assign);
	BRAINTREE_IFRAME_SELECTORS.forEach((selector) => assign(doc.querySelector(selector)));
};

/**
 * Restore keyboard tab order for hosted payment iframes when returning to scene 1
 * (e.g. change payment, change address, or shipping sync failure rollback from scene 2).
 *
 * @param {Document} [doc]
 */
export const restoreScene1PaymentFieldTabOrder = (doc = typeof document !== 'undefined' ? document : null) => {
	syncPaymentFieldTabOrder(1, doc);
};
